import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'sbnb-connect-agoda-requirements',
  templateUrl: './connect-agoda-requirements.component.html',
  styleUrls: ['./connect-agoda-requirements.component.scss'],
})
export class ConnectAgodaRequirementsComponent implements OnInit {
  multipleRooms: boolean | null = null;

  @Output() stepComplete: EventEmitter<boolean> = new EventEmitter();

  constructor(private router: Router) { }

  ngOnInit(): void { }

  progress() {
    if (this.multipleRooms === true) {
      this.router.navigate(['/accounts/new/agoda/requirements-fail'], {
        queryParams: {
          failed: 'multipleRooms',
        },
      });
      return;
    }

    if (this.multipleRooms === false) {
      this.stepComplete.emit(true);
    }
  }
}
